import React from 'react';
export function TransitionSection() {
  return <section className="py-24 px-4 bg-gradient-to-b from-cream to-secondary/10 relative" data-id="element-195">
      <div className="max-w-4xl mx-auto text-center" data-id="element-196">
        <p className="text-2xl md:text-3xl text-warm-800 font-medium leading-relaxed mb-8" data-id="element-197">
          La realidad es que la Air Fryer puede convertirse en el
          electrodoméstico más útil de tu cocina. Pero solo si sabés exactamente
          qué cocinar y cómo hacerlo correctamente.
        </p>

        <h2 className="text-4xl md:text-5xl font-bold text-primary inline-block relative" data-id="element-198">
          Por eso creamos esta guía.
          <div className="absolute -bottom-4 left-0 w-full h-1 bg-primary/50 rounded-full" data-id="element-199"></div>
        </h2>
      </div>
    </section>;
}